import script from "./iosVibrations.vue?vue&type=script&lang=js"
export * from "./iosVibrations.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__